import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-payplug-ae-file-exporter-configuration',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './payplug-ae-file-exporter-configuration.component.html',
  styleUrls: ['./payplug-ae-file-exporter-configuration.component.scss']
})
export class PayplugAccountingEntriesFileExporterConfigurationComponent {
  formGroup: FormGroup;

  constructor(
    readonly fb: FormBuilder

  ) {
    this.formGroup = fb.group({});
  }
}